import { defineMessages } from "react-intl";

/** Texts of the authenticator set-up and code fields, shared by the login steps and Settings. */
export const twoFactorMessages = defineMessages({
  qrLabel: {
    id: "twoFactor.qr.label",
    defaultMessage: "QR code to add S-Trust Explorer to your authenticator app",
  },
  scan: {
    id: "twoFactor.setup.scan",
    defaultMessage:
      "Scan the QR code with an authenticator app (for example Google Authenticator, Microsoft Authenticator or 1Password).",
  },
  secretLabel: {
    id: "twoFactor.setup.secretLabel",
    defaultMessage: "Or type this key in the app",
  },
  secretCopy: { id: "twoFactor.setup.secretCopy", defaultMessage: "Copy key" },
  secretOnce: {
    id: "twoFactor.setup.secretOnce",
    defaultMessage: "This key is shown only now. S-Trust does not keep it.",
  },
  code: { id: "twoFactor.code.label", defaultMessage: "6-digit code" },
  codeHint: {
    id: "twoFactor.code.hint",
    defaultMessage: "The code your authenticator app shows now.",
  },
  codeInvalid: { id: "twoFactor.code.invalid", defaultMessage: "Enter the 6 digits of the code." },
  confirm: { id: "twoFactor.setup.confirm", defaultMessage: "Confirm and turn on" },
  preparing: {
    id: "twoFactor.setup.preparing",
    defaultMessage: "Preparing your authenticator key",
  },
});
